import { masterDataActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
    loading: false,
    loaded: false,
};

export const reducer = createReducer(initialState, {
    [masterDataActions.loadRequest]: (state, action) => {
        state.loading = true;
        state.loaded = false;
    },
    [masterDataActions.loadSuccess]: (state, action) => {

        var result = { ...state, ...action.payload.entities };
        result.loading = false;
        result.loaded = true;
        return result;
    },
    [masterDataActions.loadFailure]: (state, action) => {
        log.error('Error loading master data.  error: ' + action.payload.error);
        state.loading = false;
        state.loaded = false;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        var result = { ...state, ...action.payload.masterData.entities };
        result.loading = false;
        result.loaded = true;
        return result;
    },
    [userActions.selectCompanyRequest]: (state, action) => {
        state.loading = true;
    }
})


